import { Award, Heart, Users } from "lucide-react";
import { IMAGES } from "../../lib/site";
import { Eyebrow, Reveal } from "./Reveal";

const STATS = [
    { icon: Award, value: "12+ anni", label: "di esperienza e formazione continua" },
    { icon: Heart, value: "STOTT PILATES®", label: "certificazione internazionale" },
    { icon: Users, value: "Max 4", label: "allievi per ogni classe di gruppo" },
];

export default function Instructor() {
    return (
        <section id="studio" data-testid="instructor-section" className="border-b border-hairline bg-white px-5 py-24 sm:px-8 md:py-32">
            <div className="mx-auto grid max-w-6xl items-center gap-14 md:grid-cols-2">
                <Reveal className="relative">
                    <div className="overflow-hidden border border-hairline">
                        <img
                            src={IMAGES.instructor}
                            alt="La sala dello studio Kore a Cernobbio"
                            loading="lazy"
                            className="aspect-[3/4] w-full object-cover"
                        />
                    </div>
                    <div className="absolute -bottom-8 -right-2 hidden w-44 overflow-hidden border border-hairline bg-white sm:block md:-right-8">
                        <img
                            src={IMAGES.teaching}
                            alt="Dettaglio dello studio Kore in travertino"
                            loading="lazy"
                            className="h-56 w-full object-cover"
                        />
                    </div>
                </Reveal>

                <div>
                    <Reveal>
                        <Eyebrow>Lo studio</Eyebrow>
                        <h2 className="mt-6 text-3xl font-light leading-tight tracking-[-0.02em] text-ink sm:text-5xl">
                            Sara, la cura del dettaglio
                        </h2>
                        <p className="mt-8 font-accent text-xl font-medium italic leading-relaxed text-ink sm:text-2xl">
                            «Il Pilates non è una sequenza di esercizi: è un dialogo
                            con il proprio corpo. Nel mio studio ogni allievo è
                            seguito personalmente, perché la precisione nasce
                            dall'attenzione.»
                        </p>
                        <p className="mt-5 text-sm font-light leading-relaxed text-mute">
                            Fondatrice e senior instructor, Sara ha portato il
                            metodo Pilates a Cernobbio dopo anni di formazione tra
                            New York e Sydney, scegliendo il lago come casa.
                        </p>
                    </Reveal>

                    <div className="mt-12">
                        {STATS.map((s, i) => (
                            <Reveal key={s.value} delay={0.1 + i * 0.08}>
                                <div className="flex items-center gap-5 border-t border-hairline py-5 last:border-b">
                                    <span className="flex h-11 w-11 shrink-0 items-center justify-center border border-hairline text-ink">
                                        <s.icon className="h-5 w-5" strokeWidth={1.5} />
                                    </span>
                                    <div>
                                        <p className="text-lg font-semibold tracking-tight text-ink">{s.value}</p>
                                        <p className="text-[11px] uppercase tracking-[0.16em] text-mute">{s.label}</p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
